import { styled } from 'buttered';
import Updating from './_updating';

let Wrapper = styled('div')`
  height: 100%;
  display: grid;
  grid-template-columns: auto 600px;

  @media screen and (max-width: 1050px) {
    display: block;
  }
`;

let Filler = styled('div')`
  overflow: hidden;
  position: relative;

  @media screen and (max-width: 1050px) {
    display: none;
  }
`;

let TextContent = styled('aside')`
  bottom: 50px;
  right: 100px;
  top: 50px;
  position: absolute;
  color: white;
  text-align: right;
`;

let Background = styled('div')`
  background-color: #00b6f6;
  filter: blur(10px);
  background: url(/auth_bg2.svg) no-repeat center center fixed;
  background-size: 140% 140%;
  width: 120vw;
  height: 120vh;
  transform: translate(-10vw, -10vh);
`;

let Content = styled('main')`
  height: 100%;
`;

let ContentInner = styled('main')`
  height: 100%;
  max-width: 600px;
  margin: 0px auto;
`;

// export default function Index() {
//   return (
//     <Wrapper>
//       <Filler>
//         <Background />

//         <TextContent>
//           <VerticalCenter>
//             <div>
//               <MainHeader>Welcome to Weekrise!</MainHeader>
//               <BigSubtitle>The easiest way to manage your life.</BigSubtitle>
//             </div>
//           </VerticalCenter>
//         </TextContent>
//       </Filler>

//       <Content>
//         <ContentInner>
//           <Auth type="signup" />
//         </ContentInner>
//       </Content>
//     </Wrapper>
//   );
// }

export default function Index() {
  return <Updating />;
}
